import { sliderClasses } from '@mui/material/Slider';
// ----------------------------------------------------------------------
export function slider(theme) {
    const lightMode = theme.palette.mode === 'light';
    return {
        MuiSlider: {
            styleOverrides: {
                root: {
                    [`&.${sliderClasses.disabled}`]: {
                        color: theme.palette.action.disabled
                    }
                },
                rail: {},
                markLabel: {
                    fontSize: 13,
                    color: theme.palette.text.disabled
                },
                valueLabel: {
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%) !important',
                    backgroundColor: 'transparent',
                    color: theme.palette.common.white,
                    fontWeight: 600,
                    fontSize: 12,
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    pointerEvents: 'none',
                    [`&.${sliderClasses.valueLabelOpen}`]: {
                        transform: 'translate(-50%, -50%) scale(1) !important'
                    },
                    [`& > *`]: {
                        transform: 'none'
                    }
                }
            }
        }
    };
}
